module.exports = __webpack_public_path__ + "files/e6683dcb560302a9211ef9db1cdb2aaa.png";